function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilitySemiOpenairBathFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.825 4.344l-4.414 4.05-2.18-1.754-5.454 4.391 1.151 1.43 4.304-3.465 4.41 3.684 1.151-1.43-1.935-1.692 3.051-2.8 7.171 5.706 1.144-1.436-8.4-6.684zM22.837 21.768v2.208c.938.506 1.3 1.012 1.3 1.33 0 .396-.537 1.073-2.05 1.685-1.608.65-3.771 1.009-6.088 1.009-2.316 0-4.476-.358-6.085-1.01-1.514-.611-2.051-1.288-2.051-1.683 0-.32.363-.825 1.3-1.331v-2.208c-2.128.86-3.3 2.118-3.3 3.539 0 1.42 1.171 2.678 3.3 3.539C11.006 29.59 13.434 30 16 30c2.568 0 4.995-.41 6.838-1.154 2.128-.861 3.3-2.118 3.3-3.54 0-1.42-1.172-2.677-3.3-3.538z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.858 19.673c-.43-.43-.666-1-.666-1.607s.236-1.178.666-1.607c.417-.417.729-.9.937-1.414h-2.351a4.241 4.241 0 00-1.252 3.02c0 1.142.444 2.215 1.252 3.022a2.274 2.274 0 010 3.213 4.26 4.26 0 00-.938 1.415h2.352a4.279 4.279 0 000-6.042zM12.587 19.673c-.43-.43-.666-1-.666-1.607s.236-1.178.666-1.607c.417-.417.73-.9.937-1.414h-2.35a4.241 4.241 0 00-1.253 3.02c0 1.142.444 2.215 1.252 3.022a2.274 2.274 0 010 3.213 4.26 4.26 0 00-.938 1.415h2.352a4.279 4.279 0 000-6.042z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.222 19.673a2.275 2.275 0 010-3.214c.411-.411.726-.891.937-1.414h-2.35a4.279 4.279 0 000 6.042c.43.429.665 1 .665 1.607 0 .606-.236 1.177-.666 1.606-.416.417-.729.9-.937 1.415h2.351a4.241 4.241 0 001.252-3.021 4.24 4.24 0 00-1.252-3.021zM27.82 4.03H4.18V11H27.82V4.03zm-25.641-2V13H29.82V2.03H2.179z",
    fill: props.color
  }));
}

export default SvgIconFacilitySemiOpenairBathFilled;